import get from 'lodash.get';

import { emptyObject } from '../../../default-props/empty';

export const selectBulkUpdateJob = (state, { bulkUpdateJobId }) =>
  get(state, `jobIdtoJobMap.${bulkUpdateJobId}`, {
    dataType: '',
    ids: [],
    model: {},
    bulkActions: [],
  });
const selectJobIdToJobMap = (state) => get(state, 'jobIdtoJobMap', emptyObject);
export const selectLastAddedJobId = (state) => get(state, 'lastAddedJobId', '');
const selectDrawerBulkUpdate = (state) => get(selectJobIdToJobMap(state), 'drawer-bulk-update');
export const selectDrawerBulkUpdateProperty = (state, props) => get(selectDrawerBulkUpdate(state), props.property);
